import * as React from "react";
import { PlayerCardDefault } from "../../../services/bedrock";
import { Dropdown, DropdownItemProps } from "semantic-ui-react";
import { useContext, useState } from "react";
import _ from "lodash";
import { PlayerCardSettingsContext } from "../Contexts";

interface DefaultDropdownProps {
  type: "Theme" | "Template";
  segmentationDetailId?: number;
  defaultRecord?: PlayerCardDefault;
  options: DropdownItemProps[];
  onChange: () => void;
}

const DefaultDropdown: React.FC<DefaultDropdownProps> = ({
  type,
  segmentationDetailId,
  defaultRecord,
  options,
  onChange,
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const { Themes, Templates } = useContext(PlayerCardSettingsContext);

  return (
    <Dropdown
      loading={isSaving}
      disabled={isSaving}
      options={options}
      defaultValue={defaultRecord?.defaultId}
      clearable
      selection
      fluid
      placeholder={`Select ${type}`}
      onChange={(e, data) => {
        const defaultId = data.value as number;
        const defaultRecordId = defaultRecord?.id;
        var promise: Promise<any> | null = null;
        const context = type === "Theme" ? Themes : Templates;
        if (!_.isInteger(defaultId)) {
          if (defaultRecordId) {
            promise = context.deleteDefault(defaultRecordId);
          }
        } else if (defaultRecordId) {
          promise = context.updateDefault(defaultRecord.id, defaultId, segmentationDetailId);
        } else {
          promise = context.createDefault(defaultId, segmentationDetailId);
        }

        if (promise) {
          setIsSaving(true);
          promise.then(onChange).finally(() => setIsSaving(false));
        }
      }}
    />
  );
};
export default DefaultDropdown;
